import { getMyList, getPdNoReplyChatBoxesPage } from '@/api/dialogue';
import { getCorrespondenceStatisticByToken } from '@/api/talkytimes/user';
import { createSocketsForUsers } from '@/utils/talky_muti_chat.js';

const state = {
  accountList: [], // 账号列表
  loading: false, // 加载状态
  error: null, // 错误信息
  lastFetchTime: null, // 最后获取时间
  cacheExpireTime: 5 * 60 * 1000, // 缓存过期时间（5分钟）
  accountPromise: null, // 账号列表Promise
  isFirst: false, // 是否已初始化未读数量
};

const mutations = {
  SET_ACCOUNT_LIST(state, accountList) {
    state.accountList = accountList;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_LAST_FETCH_TIME(state, time) {
    state.lastFetchTime = time;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  },
  SET_ACCOUNT_UNREAD_COUNT(state, { accountId, count }) {
    state.accountList.forEach((account) => {
      if (account.id == accountId) {
        account.unreadCount = count;
      }
    });
    // 强制触发响应式更新
    state.accountList = [...state.accountList];
  },
  UPDATE_TOTAL_UNREAD_COUNT(state, count) {
    // 根据新消息数量更新未读消息总数
    // 这里我们只更新第一个账号的未读数量，因为新消息通常属于当前活跃账号
    if (state.accountList.length > 0) {
      state.accountList[0].unreadCount = count;
    }

    // 强制触发响应式更新
    state.accountList = [...state.accountList];
  },

  UPDATE_UNREAD_COUNT_BY_NEW_MESSAGES(state, newMessages) {
    // 简化逻辑：直接使用新消息数量更新第一个账号的未读数量
    // 这样可以确保顶部气泡显示的数量与左侧新消息列表的数量一致
    if (state.accountList.length > 0) {
      state.accountList[0].unreadCount = newMessages.length;
    }

    // 强制触发响应式更新
    state.accountList = [...state.accountList];
  },
};

const actions = {
  loopGetUnreadCount({ state, commit, dispatch }) {
    const accountList = state.accountList;
    console.log('accountList::::::', accountList);

    // 只有在账号列表已存在时才执行未读数量获取
    if (accountList && accountList.length > 0) {
      dispatch('executeUnreadCountFetch');
    } else {
      console.log(
        '账号列表为空，跳过未读数量获取（将在账号列表获取后自动执行）'
      );
    }
  },

  // 执行未读数量获取
  async executeUnreadCountFetch({ state, commit, dispatch }) {
    // 使用 getPdNoReplyChatBoxesPage 获取新消息列表（与 newMessageCard 组件保持一致）
    const response = await getPdNoReplyChatBoxesPage({
      limit: 100, // 设置一个合理的limit来获取所有新消息
      offset: 0,
      type: 0, // type=0表示新消息
    });

    if (response && response.code === 200 && response.data) {
      // 使用新消息列表更新未读数量
      dispatch('updateUnreadCountByNewMessages', response.data);
    }

    // 保留原来的接口调用方式（注释掉，避免影响现有功能）
    // const accountList = state.accountList;
    // if (accountList && accountList.length > 0) {
    //   accountList.forEach((account) => {
    //     getCorrespondenceStatisticByToken({ pdToken: account.pdToken }).then(
    //       (res) => {
    //         console.log('res::::::', res);
    //         if (res) {
    //           commit('SET_ACCOUNT_UNREAD_COUNT', {
    //             accountId: account.id,
    //             count: res.threadsUnreadCount,
    //           });
    //         }
    //       }
    //     );
    //   });
    // }
  },

  // 更新总的未读消息数量
  updateTotalUnreadCount({ commit }, count) {
    commit('UPDATE_TOTAL_UNREAD_COUNT', count);
  },

  // 根据新消息数据更新未读数量
  updateUnreadCountByNewMessages({ commit }, newMessages) {
    commit('UPDATE_UNREAD_COUNT_BY_NEW_MESSAGES', newMessages);
  },
  // 获取账号列表
  async fetchAccountList({ state, commit, dispatch }, forceRefresh = false) {
    // 检查是否需要刷新数据
    const now = Date.now();
    const shouldRefresh =
      forceRefresh ||
      !state.lastFetchTime ||
      now - state.lastFetchTime > state.cacheExpireTime ||
      state.accountList.length === 0;

    if (!shouldRefresh) {
      return state.accountList;
    }

    // // 如果正在加载，直接返回当前数据
    // if (state.loading) {
    //   return state.accountList;
    // }

    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');

    try {
      // 等待 Promise 完成
      const response = await getMyList();
      if (response && response.data) {
        const accountList = response.data;
        commit('SET_ACCOUNT_LIST', accountList);
        commit('SET_LAST_FETCH_TIME', now);

        // 设置默认token和用户tokens到localStorage
        if (accountList.length > 0) {
          localStorage.setItem('activeUser', JSON.stringify(accountList[0]));
          localStorage.setItem('userTokens', JSON.stringify(accountList));

          // 为所有用户创建Socket连接
          const userList = accountList.map((item) => {
            return {
              ...item,
              token: item.pdToken,
            };
          });
          createSocketsForUsers(userList);

          // 只在首次获取账号列表时获取未读数量
          if (!this.isFirst) {
            dispatch('executeUnreadCountFetch');
            this.isFirst = true;
          }
        }

        return accountList;
      } else {
        throw new Error('获取账号列表失败');
      }
    } catch (error) {
      console.error('获取账号列表失败:', error);
      commit('SET_ERROR', error.message || '获取账号列表失败');
      return [];
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 刷新账号列表
  async refreshAccountList({ dispatch }) {
    return await dispatch('fetchAccountList', true);
  },

  // 清除账号列表
  clearAccountList({ commit }) {
    commit('SET_ACCOUNT_LIST', []);
    commit('SET_LAST_FETCH_TIME', null);
    commit('CLEAR_ERROR');
  },
};

const getters = {
  // 获取账号列表
  getAccountList: (state) => state.accountList,

  // 获取加载状态
  isLoading: (state) => state.loading,

  // 获取错误信息
  getError: (state) => state.error,

  // 获取账号数量
  getAccountCount: (state) => state.accountList.length,

  // 根据ID获取账号
  getAccountById: (state) => (id) => {
    return state.accountList.find((account) => account.id === id);
  },

  // 检查是否有数据
  hasData: (state) => state.accountList.length > 0,

  // 检查数据是否过期
  isDataExpired: (state) => {
    if (!state.lastFetchTime) return true;
    const now = Date.now();
    return now - state.lastFetchTime > state.cacheExpireTime;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
